/**
 * Constantes e funções utilitárias para validação do cliente ELI LILLY
 * 
 * Este arquivo segue o mesmo padrão de implementação do abbottClient.ts
 * para manter consistência no código.
 */

/** 
 * Nomes legais do cliente (campo `name` / value do autocomplete) 
 * que habilitam os campos gerenciais ELI LILLY.
 * 
 * Caso existam outras razões sociais da ELI LILLY no futuro,
 * basta adicioná-las neste array.
 */
export const ELI_LILLY_CLIENT_NAMES = [
  "ELI LILLY",
] as const;

/**
 * Normaliza o nome do cliente para comparação.
 * 
 * Remove espaços extras, converte para maiúsculas e garante
 * que o valor seja sempre uma string válida.
 * 
 * @param name - Nome do cliente (pode ser null ou undefined)
 * @returns Nome normalizado em maiúsculas
 */
export function normalizeClientNameForEliLilly(name?: string | null): string {
  return String(name ?? "")
    .trim()
    .toUpperCase();
}

/**
 * Verifica se o cliente selecionado é ELI LILLY.
 * 
 * Compara o nome normalizado do cliente com a lista de nomes
 * legais cadastrados para ELI LILLY.
 * 
 * @param clientName - Nome do cliente a ser validado
 * @returns true se o cliente for ELI LILLY, false caso contrário
 * 
 * @example
 * isEliLillyClient("ELI LILLY") // true
 * isEliLillyClient("eli lilly") // true (normalização automática)
 * isEliLillyClient("Outro Cliente") // false
 */
export function isEliLillyClient(clientName?: string | null): boolean {
  const normalized = normalizeClientNameForEliLilly(clientName);
  if (!normalized) return false;
  return (ELI_LILLY_CLIENT_NAMES as readonly string[]).includes(normalized);
}
